
    import './styles.scoped.css';
    export default {
  "background": "awsui_background_hyvsj_1tx15_93",
  "scrolling-background": "awsui_scrolling-background_hyvsj_1tx15_96",
  "sticky-background": "awsui_sticky-background_hyvsj_1tx15_102",
  "has-sticky-notifications": "awsui_has-sticky-notifications_hyvsj_1tx15_110",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_1tx15_123",
  "has-sticky-background": "awsui_has-sticky-background_hyvsj_1tx15_133",
  "drawers-container": "awsui_drawers-container_hyvsj_1tx15_145",
  "has-open-drawer": "awsui_has-open-drawer_hyvsj_1tx15_156",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_1tx15_179",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_1tx15_184",
  "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_1tx15_203",
  "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_hyvsj_1tx15_213",
  "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_1tx15_217",
  "drawers-trigger-overflow": "awsui_drawers-trigger-overflow_hyvsj_1tx15_231",
  "drawers-trigger": "awsui_drawers-trigger_hyvsj_1tx15_217",
  "drawer": "awsui_drawer_hyvsj_1tx15_145",
  "drawer-content-container": "awsui_drawer-content-container_hyvsj_1tx15_261",
  "drawer-close-button": "awsui_drawer-close-button_hyvsj_1tx15_270",
  "drawer-content": "awsui_drawer-content_hyvsj_1tx15_261",
  "drawer-content-hidden": "awsui_drawer-content-hidden_hyvsj_1tx15_278",
  "drawer-slider": "awsui_drawer-slider_hyvsj_1tx15_281",
  "is-drawer-open": "awsui_is-drawer-open_hyvsj_1tx15_288",
  "content": "awsui_content_hyvsj_1tx15_314",
  "layout": "awsui_layout_hyvsj_1tx15_335",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_1tx15_418",
  "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_1tx15_433",
  "content-type-table": "awsui_content-type-table_hyvsj_1tx15_447",
  "content-type-cards": "awsui_content-type-cards_hyvsj_1tx15_447",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_1tx15_453",
  "is-hide-mobile-toolbar": "awsui_is-hide-mobile-toolbar_hyvsj_1tx15_456",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_1tx15_488",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_1tx15_491",
  "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_1tx15_501",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_1tx15_504",
  "content-first-child-header": "awsui_content-first-child-header_hyvsj_1tx15_507",
  "has-header": "awsui_has-header_hyvsj_1tx15_507",
  "content-first-child-main": "awsui_content-first-child-main_hyvsj_1tx15_528",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_1tx15_528",
  "has-split-panel": "awsui_has-split-panel_hyvsj_1tx15_571",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_1tx15_571",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_1tx15_587",
  "unfocusable": "awsui_unfocusable_hyvsj_1tx15_592",
  "container": "awsui_container_hyvsj_1tx15_602",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_1tx15_627",
  "is-tools-open": "awsui_is-tools-open_hyvsj_1tx15_630",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_1tx15_630",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_1tx15_630",
  "has-active-drawer": "awsui_has-active-drawer_hyvsj_1tx15_630",
  "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_1tx15_639",
  "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_1tx15_655",
  "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_1tx15_659",
  "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_1tx15_663",
  "navigation-container": "awsui_navigation-container_hyvsj_1tx15_672",
  "show-navigation": "awsui_show-navigation_hyvsj_1tx15_716",
  "animating": "awsui_animating_hyvsj_1tx15_738",
  "showButtons": "awsui_showButtons_hyvsj_1tx15_1",
  "navigation": "awsui_navigation_hyvsj_1tx15_672",
  "openNavigation": "awsui_openNavigation_hyvsj_1tx15_1",
  "animated-content": "awsui_animated-content_hyvsj_1tx15_800",
  "hide-navigation": "awsui_hide-navigation_hyvsj_1tx15_809",
  "notifications": "awsui_notifications_hyvsj_1tx15_819",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_1tx15_825",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_1tx15_842",
  "position-bottom": "awsui_position-bottom_hyvsj_1tx15_889",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_1tx15_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_1tx15_918",
  "position-side": "awsui_position-side_hyvsj_1tx15_931",
  "tools-container": "awsui_tools-container_hyvsj_1tx15_953",
  "tools": "awsui_tools_hyvsj_1tx15_953",
  "openTools": "awsui_openTools_hyvsj_1tx15_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_1tx15_1050",
  "hide-tools": "awsui_hide-tools_hyvsj_1tx15_1060",
  "show-tools": "awsui_show-tools_hyvsj_1tx15_1072",
  "has-tools-form": "awsui_has-tools-form_hyvsj_1tx15_1050",
  "trigger-badge-wrapper": "awsui_trigger-badge-wrapper_hyvsj_1tx15_1132",
  "trigger": "awsui_trigger_hyvsj_1tx15_1132",
  "selected": "awsui_selected_hyvsj_1tx15_1195",
  "badge": "awsui_badge_hyvsj_1tx15_1215",
  "trigger-wrapper": "awsui_trigger-wrapper_hyvsj_1tx15_1219",
  "dot": "awsui_dot_hyvsj_1tx15_1225"
};
  